/* eslint-disable jsx-a11y/click-events-have-key-events */
import { IconCheck } from "@tabler/icons-react";
import React, {
  ReactNode,
} from "react";

import { checkboxStyle } from "../../Checkbox/Checkbox";

export enum InputState {
  default = "default",
  error = "error",
  success = "success",
}

export interface OptionProps {
  label: string;
  subLabel?: string;
  icon?: ReactNode;
  value: string;
  selected?: boolean;
  highlighted?: boolean;
  disabled?: boolean;
  checkbox?: boolean;
  onClick?: (value: string, e: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
}

const getStyle = (selected: boolean, highlighted: boolean, disabled: boolean) => {
  if (disabled) return "text-text-disabled bg-bg-disabled border-border-disabled cursor-not-allowed";
  if (selected) return "bg-bg-interactive-light cursor-pointer";
  if (highlighted) return "bg-bg-components-hover cursor-pointer";
  return "bg-bg-components-base hover:bg-bg-components-hover cursor-pointer";
};

const Option = ({
  label, subLabel, icon, value, selected, highlighted, disabled, checkbox, onClick,
}: OptionProps) => (
  <div
    className={`flex flex-nowrap items-center appearance-none w-full px-5 py-2.5 gap-3 text-text-base relative
      ${getStyle(selected, highlighted, disabled)}`}
    onClick={(e) => (disabled ? null : onClick(value, e))}
  >
    {selected && !checkbox && (
      <div className="w-5 text-icon-interactive"><IconCheck /></div>
    )}
    {/* {highlighted && (
      <div className="absolute rounded-full h-2 w-2 left-2 top-4 bg-blue-700" />
    )} */}
    {checkbox && (
      <div className="relative flex items-center">
        <input
          disabled={disabled}
          type="checkbox"
          className={checkboxStyle}
          checked={selected}
        />
        <div className={`absolute pointer-events-none z-1 top-0 left-0 ${disabled ? "text-icon-disabled" : "text-icon-on-color"} ${selected ? "" : "hidden"}`}>
          <IconCheck />
        </div>
      </div>

    )}
    <div className="grow typography-medium-base">
      {label}
    </div>
    {subLabel && (
      <div className="grow text-text-subtle typography-small-base text-right">
        {subLabel}
      </div>
    )}
    {icon && (<div className="flex-none">{icon}</div>)}
  </div>
);

export default Option;
